import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { GLOBAL } from './global';

@Injectable({
  providedIn: 'root'
})
export class ScrapService {
  private url: string;
  public token;
  public headers: HttpHeaders;

  constructor(private httpClient: HttpClient) {
    //this.url = 'https://greenteksolutions.com/backend/crm/web/';
    this.url = GLOBAL.url;
    this.token = JSON.parse(localStorage.getItem("token"));
    if (this.token === "undefined") {
      this.token = null;
    }
    this.headers = new HttpHeaders({
      "Content-Type": "application/x-www-form-urlencoded",
      "X-Requested-With": "XMLHttpRequest",
    });
  }

  newElement(token, task): Observable<any> {
    const json = JSON.stringify(task);
    const params = new URLSearchParams();
    params.set('json', json);
    params.set('authorization', token);
    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
      'X-Requested-With': 'XMLHttpRequest'
    });
    const page = 1;

    return this.httpClient.post<any>(
      `${this.url}/scrapitem/new?page=${page}`,
      params.toString(),
      { headers }
    );
  }

  newCategory(token, task): Observable<any> {
    const json = JSON.stringify(task);
    const params = new URLSearchParams();
    params.set('json', json);
    params.set('authorization', token);
    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
      'X-Requested-With': 'XMLHttpRequest'
    });
    const page = 1;

    return this.httpClient.post<any>(
      `${this.url}/scrapcategory/new?page=${page}`,
      params.toString(),
      { headers }
    );
  }

  getAll(token,status, page = 1, perPage: any = 'ALL',sort = '', sortby = '', busqueda = '',location=''): Observable<any> {
    const params = new URLSearchParams();
    params.set('authorization', token);
    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
      'X-Requested-With': 'XMLHttpRequest'
    });

    let url = `${this.url}/scrapitem/alllisttype/${status}?page=${page}&perpage=${perPage}&location=${location}`;

    if (sortby !== '') {
      if (sort === '') {
        sort = 'DESC';
      }
      url += `&order=${sort}&orderby=${sortby}`;
    }

    if (busqueda !== '') {
      const task = {
        search: busqueda
      };
      const json = JSON.stringify(task);
      params.set('json', json);
    }

    return this.httpClient.post<any>(url, params.toString(), { headers });
  }

  getAllFilters(token, status, page = 1, perPage = 10, busqueda = "", filtros = []): Observable<any> {

    let url = `${this.url}/scrapitem/alllisttypefilters/${status}?`;

    let json = null;
    if (busqueda !== "") {
      json = {
        busqueda: busqueda,
      };
    }

    console.log(json);

    url = url + 'page=' + page + '&perpage=' + perPage;

    for (let filtro of filtros) {
      if (filtro && filtro.value) {
        url = url + "&" + filtro.key + "=" + filtro.value;

        if (filtro.type) {
          url = url + "&" + filtro.key_type + "=" + filtro.type;

        }
      }
    }

    return this.petition(
      url,
      json
    );
  }

  getAllFiltersv2(token, status, page = 1, perPage = 10, busqueda = "", filtros = [],task:any,
    order:any): Observable<any> {

    let url = `${this.url}/scrapitem/alllisttypefilters/${status}?`;

    let json = null;
    if (busqueda !== "") {
      json = {
        busqueda: busqueda,
      };
    }
    if (task) {
      
      if (!json) {
        json = {};
      }
     
      json.sort = [task];
    }
    if (order) {
      
      if (!json) {
        json = {};
      }
      json.order = order;
    }
    console.log(json);

    url = url + 'page=' + page + '&perpage=' + perPage;

    for (let filtro of filtros) {
      if (filtro && filtro.value) {
        url = url + "&" + filtro.key + "=" + filtro.value;

        if (filtro.type) {
          url = url + "&" + filtro.key_type + "=" + filtro.type;

        }
      }
    }

    return this.petition(
      url,
      json
    );
  }

  getOne(token, id, page = null): Observable<any> {
    const params = new URLSearchParams();
    params.set('authorization', token);
    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
      'X-Requested-With': 'XMLHttpRequest'
    });

    if (page == null) {
      page = 1;
    }

    return this.httpClient.post<any>(
      `${this.url}/scrapitem/detail/${id}?page=${page}`,
      params.toString(),
      { headers }
    );
  }

  getCategories(token): Observable<any> {
    const params = new URLSearchParams();
    params.set('authorization', token);
    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
      'X-Requested-With': 'XMLHttpRequest'
    });
    const page = 1;

    return this.httpClient.post<any>(
      `${this.url}/scrapcategory/list?page=${page}`,
      params.toString(),
      { headers }
    );
  }

  getScrapsByFather(token, id, hideprocessed = 0): Observable<any> {
    const task = {
      onlyprocessed: hideprocessed
    };
    const json = JSON.stringify(task);
    const params = new URLSearchParams();
    params.set('json', json);
    params.set('authorization', token);
    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
      'X-Requested-With': 'XMLHttpRequest'
    });

    return this.httpClient.post<any>(
      `${this.url}/weightitem/listscrapsavailablesbyfather/${id}?page=1`,
      params.toString(),
      { headers }
    );
  }

  edit(token, id, task): Observable<any> {
    const json = JSON.stringify(task);
    const params = new URLSearchParams();
    params.set('json', json);
    params.set('authorization', token);
    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
      'X-Requested-With': 'XMLHttpRequest'
    });
    const page = 1;

    return this.httpClient.post<any>(
      `${this.url}/scrapitem/edit/${id}?page=${page}`,
      params.toString(),
      { headers }
    );
  }

  delete(token, id): Observable<any> {
    const params = new URLSearchParams();
    params.set('authorization', token);
    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
      'X-Requested-With': 'XMLHttpRequest'
    });
    const page = 1;

    return this.httpClient.post<any>(
      `${this.url}/scrapitem/remove/${id}?page=${page}`,
      params.toString(),
      { headers }
    );
  }

  deleteShipped(token, id): Observable<any> {
    const params = new URLSearchParams();
    params.set('authorization', token);
    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
      'X-Requested-With': 'XMLHttpRequest'
    });
    const page = 1;

    return this.httpClient.post<any>(
      `${this.url}/scrapitem/removeshipped/${id}?page=${page}`,
      params.toString(),
      { headers }
    );
  }

  deleteBulk(token, task): Observable<any> {
    const json = JSON.stringify(task);
    const params = new URLSearchParams();
    params.set('json', json);
    params.set('authorization', token);
    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
      'X-Requested-With': 'XMLHttpRequest'
    });
    const page = 1;

    return this.httpClient.post<any>(
      `${this.url}/scrapitem/removebulk?page=${page}`,
      params.toString(),
      { headers }
    );
  }

  listByLot(token, lot): Observable<any> {
    const params = new URLSearchParams();
    params.set('authorization', token);
    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
      'X-Requested-With': 'XMLHttpRequest'
    });
    
   const page = 1
    return this.httpClient.post<any>(
      `${this.url}/scrapitem/listbylot/${lot}?page=${page}`,
      params.toString(),
      { headers }
    );
  }
  /*  */
  listByLotV2(token, lot,page,perpage,filtros = [],task:any,
    order:any): Observable<any> {
    const params = new URLSearchParams();
    params.set('authorization', token);
    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
      'X-Requested-With': 'XMLHttpRequest'
    });
    
    let url = this.url + `/scrapitem/listbylot/${lot}?page=${page}&perpage=${perpage}`;
    const json = { sort:[task], order:order };
    for (let filtro of filtros) {      
      if (filtro && filtro.value) {
        console.log(filtro.key);
        url = url + "&" + filtro.key + "=" + encodeURIComponent(filtro.value);
  
        if (filtro.type) {
          url = url + "&" + filtro.key_type + "=" + filtro.type;
        }
      }
    }
    return this.petition(url,json);

  }



  reportShippedByDate(token, task): Observable<any> {
    const json = JSON.stringify(task);
    const params = new URLSearchParams();
    params.set('json', json);
    params.set('authorization', token);
    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
      'X-Requested-With': 'XMLHttpRequest'
    });

    return this.httpClient.post<any>(
      `${this.url}/scrapitem/reportshippedbydate?page=1`,
      params.toString(),
      { headers }
    );
  }


  changeStatus(token, id): Observable<any> {
    const params = new URLSearchParams();
    params.set('authorization', token);
    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
      'X-Requested-With': 'XMLHttpRequest'
    });
    const page = 1;

    return this.httpClient.post<any>(
      `${this.url}/scrapitem/close/${id}?page=${page}`,
      params.toString(),
      { headers }
    );
  }

  petition(url, json = null, type = null) {
    let params = "authorization=" + this.token;

    if (json != null) {
      json = encodeURIComponent(JSON.stringify(json));
      params = params + "&json=" + json;
    }

    if (type != null) {
      params = params + "&type=" + type;
    }

    return this.httpClient.post(url, params, { headers: this.headers }).pipe(
      map((res: any) => {
        /*if (res.code === 404) {
          this.mtds.notifyError("Your session has expired");
          localStorage.clear();
          this._router.navigate(["/pages/lock"]);
        }*/
        return res;
      })
    );
  }

 
}
